const initialState = {
  currentGroup: {},
  recipient: {},
  userMessages: [],
};

const getLoggedInUserIdSafe = () => {
  try {
    return JSON.parse(localStorage.getItem("user"))?._id || null;
  } catch (e) {
    return null;
  }
};

const upsertReceiptEntry = (entries, userId, time) => {
  const safeEntries = Array.isArray(entries) ? entries : [];
  if (!userId) return safeEntries;

  const alreadyPresent = safeEntries.some((e) => e?.userId === userId);
  if (alreadyPresent) return safeEntries;

  return [
    ...safeEntries,
    {
      userId,
      userAgent: null,
      _id: userId,
      time,
    },
  ];
};

const chatHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case "RECIPIENT":
      let { receiver } = action.payload;
      return {
        ...state,
        recipient: receiver,
      };

    case "USER_MESSAGES":
      let { userMessages, unReadMessageCounter } = action.payload;

      return {
        ...state,
        userMessages: userMessages,
      };
    case "UPDATE_MESSAGE_TICK": {
      const { roomId } = action.payload;
      const currentRoomId = state.recipient?.roomId?.toString();
      if (roomId != currentRoomId) {
        return state;
      }

      const loggedInUserId = getLoggedInUserIdSafe();
      const now = Date.now();

      return {
        ...state,
        userMessages: state.userMessages.map((msg) => {
          if (!loggedInUserId) return msg;

          const senderId = msg?.senderId || msg?.senderDetails?._id;
          // Only mark messages as delivered/read for the receiver side
          if (senderId && senderId === loggedInUserId) return msg;

          return {
            ...msg,
            delivered: msg?.delivered ?? now,
            read: msg?.read ?? now,
            readBy: upsertReceiptEntry(msg?.readBy, loggedInUserId, now),
            deliveredTo: upsertReceiptEntry(msg?.deliveredTo, loggedInUserId, now),
          };
        }),
      };
    }
    case "LOAD_MORE_MESSAGES":
      let newPayload = action.payload.filter((data) => {
        let exists = state.userMessages.some((elum) => elum.id === data.id);
        return !exists;
      });
      return {
        ...state,
        userMessages: [...state.userMessages, ...newPayload].sort(
          (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
        ),
      };

    case "NEW_MESSAGES": {
      let { newMessage, roomId } = action.payload;
      const currentRoomId = state.recipient?.roomId?.toString();

      // Only accept messages for the currently active room
      if (roomId !== currentRoomId) return state;

      if (state.userMessages.length === 0) {
        return {
          ...state,
          userMessages: [newMessage],
        };
      }

      let checkSameRoomID = state.userMessages.find(
        (elum) => elum.onetooneId == roomId || elum.groupId == roomId
      );
      if (checkSameRoomID) {
        const isDuplicate = state.userMessages.some(
          (item) => item?.id === newMessage?.id
        );
        if (!isDuplicate) {
          let updatedUserMessages = [...state.userMessages];

          if (newMessage?.onetooneId) {
            updatedUserMessages = state.userMessages.map((message) => {
              if (
                message?.readBy?.length < 2 &&
                newMessage?.readBy?.length == 2
              ) {
                return {
                  ...message,
                  readBy: [
                    ...message.readBy,
                    {
                      userId: newMessage?.senderDetails?._id,
                      userAgent: null,
                      _id: newMessage?.senderDetails?._id,
                    },
                  ],
                };
              } else if (
                message?.deliveredTo?.length < 2 &&
                newMessage?.deliveredTo?.length == 2
              ) {
                return {
                  ...message,
                  deliveredTo: [
                    ...message.deliveredTo,
                    {
                      userId: newMessage?.senderDetails?._id,
                      userAgent: null,
                      _id: newMessage?.senderDetails?._id,
                    },
                  ],
                };
              }
              return message;
            });
          }
          return {
            ...state,
            userMessages: [...updatedUserMessages, newMessage].sort(
              (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
            ),
          };
        }
      }
      return state;
    }
    case "CURRENT_GROUP":
      return {
        ...state,
        currentGroup: action.payload,
      };
    default:
      return state;
  }
};

export default chatHistoryReducer;
